<template>
  <div class="index" id="Index">
    <div class="big-bg">
      <el-carousel indicator-position="none" :interval="4000">
        <el-carousel-item v-for="item in pictures" :key="item">
          <div class="pic" style="width: 100%;">
            <el-image style="width: 100%; height: auto" :src="item" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
              :preview-src-list="pictures" preview-teleported :initial-index="4" fit="cover" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <img class="big-pic" src="../../assets/imgs/breadcrumb.jpg" alt="">
    <div class="container-fluid">
      <div class="w-1200">
        <div class="title">
          <span>Services</span>
        </div>
        <div class="big-title">One-stop service covering partner visa, employer sponsorship, <br>
          Australian and New Zealand immigration/study/various visas, helping you achieve your education & migration
          goals!</div>
        <div class="text">
          We offer comprehensive services covering Partner Visas, Employer sponsorship, Australian and New Zealand
          immigration, study abroad, and various other types of visas. From application planning to document preparation
          and progress tracking, we provide a one-stop solution for your cross-border needs, helping you smoothly
          achieve your visa, immigration, and study abroad goals.
        </div>
        <div class="lists">
          <div class="list" @click="toPageFn('/en/immigration?nav_id=131')"
            v-appear-animation="{ appearClass: 'animate-slide-in-left' }">
            <div class="big-img">
              <img  src="../../assets/imgs/buxi.jpg" alt="">
            </div>
            <div class="text-title">Partner Visa</div>
            <div class="list-alert">
              <p class="alert-title">Partner Visa</p>
              <p class="alert-tip">
                <!-- 新传奇为您办理澳大利亚所有签证类别。 -->
              </p>
              <p class="alert-more">Learn More</p>
            </div>
          </div>
          <div class="list" @click="toPageFn('/en/evaluateMaster?nav_id=217&currentNav=1')"
          
            v-appear-animation="{ appearClass: 'animate-slide-in-left' }">
            <div class="big-img">
              <img
                 src="../../assets/imgs/Business-investment-immigration-1.jpg"
                alt="">
            </div>
            <div class="text-title">Employer Sponsorship</div>
            <div class="list-alert">
              <p class="alert-title">Employer Sponsorship</p>
              <p class="alert-tip">
                <!-- 新传奇为您办理澳大利亚所有签证类别。 -->
              </p>
              <p class="alert-more">Learn More</p>
            </div>
          </div>
          <div class="list" @click="toPageFn('/en/immigration?nav_id=297')"
            v-appear-animation="{ appearClass: 'animate-slide-in-left' }">
            <div class="big-img">
              <img src="../../assets/imgs/syd.jpg" alt="">
            </div>
            <div class="text-title">NIV National Innovation Visa</div>
            <div class="list-alert">
              <p class="alert-title">NIV National Innovation Visa</p>
              <p class="alert-tip">
                <!-- 新传奇为您办理 配偶移民/技术移民/雇主担保移民/家庭团聚与父母签证/移民加急与签证申诉 -->
              </p>
              <p class="alert-more">Learn More</p>
            </div>
          </div>
          <div class="list" @click="toPageFn('/en/immigration?nav_id=392&currentNav=0&currentItemNav=1')"
            v-appear-animation="{ appearClass: 'animate-slide-in-right' }">
            <div class="big-img">
              <img  src="../../assets/imgs/law.jpg" alt="">
            </div>
            <div class="text-title">Australian Higher Education</div>
            <div class="list-alert">
              <p class="alert-title">Australian Higher Education</p>
              <p class="alert-tip">
                <!-- 新传奇为您办理 澳洲中小学/澳洲本科/澳洲硕士/澳洲TAFE课程/PY/NAATI/CCL课程 -->
              </p>
              <p class="alert-more">Learn More</p>
            </div>
          </div>
          <div class="list" @click="toPageFn('/en/immigration?nav_id=392')"
            v-appear-animation="{ appearClass: 'animate-slide-in-right' }">
            <div class="big-img">
              <img src="../../assets/imgs/syd.jpg" alt="">
            </div>
            <div class="text-title">Australian Education for K-12</div>
            <div class="list-alert">
              <p class="alert-title">Australian Education for </p>
              <p class="alert-tip">
                <!-- 新传奇为您办理 工作签证/学生签证/旅游签证/其他签证 -->
              </p>
              <p class="alert-more">Learn More</p>
            </div>
          </div>
          <div class="list" @click="toPageFn('/en/immigration?nav_id=172&currentNav=1')"
            v-appear-animation="{ appearClass: 'animate-slide-in-right' }">
            <div class="big-img">
              <img  src="../../assets/imgs/syd.jpg" alt="">
            </div>
            <div class="text-title">New Zealand Investment Visa</div>
            <div class="list-alert">
              <p class="alert-title">New Zealand Investment Visa</p>
              <p class="alert-tip">
                <!-- 新传奇为您办理 新西兰投资移民 -->
              </p>
              <p class="alert-more">Learn More</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="why-choose">
      <div class="w-1200">
        <div class="title">
          <span>Online Assessment</span>
        </div>
        <div class="big-title">New Zealand Education Online Assessment Tool</div>
        <div class="text">
          We provide you with a convenient pre-application assessment service for
          all Australian & New Zealand education categories, employer sponsorship, partner visa and skilled independent
          visa EOI assessment tools to help you quickly understand your application suitability and plan your future.
        </div>
        <div class="lists">
          <div class="list" @click="toPageFn('/en/evaluateSmallStudent')"
            v-appear-animation="{ appearClass: 'animate-fade-out' }">
            <div class="img">
              <img src="../../assets/imgs/gray-why1.png" alt="">
            </div>
            <p class="list-title u-line-2">
              Australian & NZ<br>K-12 Education
            </p>
            <p class="list-text u-line-3">
              To apply for Australian secondary school, please self-assess yourself
            </p>
            <p class="more">
              Go to Assessment <i class="el-icon-arrow-right"></i>
            </p>
          </div>
          <div class="list" @click="toPageFn('/en/evaluateStudent')"
            v-appear-animation="{ appearClass: 'animate-fade-out' }">
            <div class="img">
              <img src="../../assets/imgs/gray-why1.png" alt="">
            </div>
            <p class="list-title u-line-2">
              Australian Higher<br>Education Assessment
            </p>
            <p class="list-text u-line-3">
              To apply for Australian higher education, please self-assess yourself
            </p>
            <p class="more">
              Go to Assessment <i class="el-icon-arrow-right"></i>
            </p>
          </div>
          <div class="list" @click="toPageFn('/en/evaluateEoi')"
            v-appear-animation="{ appearClass: 'animate-fade-out-2' }">
            <div class="img">
              <img src="../../assets/imgs/gray-why2.png" alt="">
            </div>
            <p class="list-title u-line-2">
              Australian EOI Assessment Self-Assessment
            </p>
            <p class="list-text u-line-3">
              To apply for Australian EOI, please self-assess yourself
            </p>
            <p class="more">
              Go to Assessment <i class="el-icon-arrow-right"></i>
            </p>
          </div>
          <div class="list" @click="toPageFn('/en/evaluateMaster')"
            v-appear-animation="{ appearClass: 'animate-fade-out-4' }">
            <div class="img">
              <img src="../../assets/imgs/gray-why3.png" alt="">
            </div>
            <p class="list-title u-line-2">
              Employer Sponsorship Self-Assessment
            </p>
            <p class="list-text u-line-3">
              To apply for employer sponsorship, please self-assess yourself
            </p>
            <p class="more">
              Go to Assessment <i class="el-icon-arrow-right"></i>
            </p>
          </div>
          <div class="list" @click="toPageFn('/en/evaluate')"
            v-appear-animation="{ appearClass: 'animate-fade-out-6' }">
            <div class="img">
              <img src="../../assets/imgs/gray-why4.png" alt="">
            </div>
            <p class="list-title u-line-2">
              Partner visa Assessment Self-Assessment
            </p>
            <p class="list-text u-line-3">
              To apply for spouse, please self-assess yourself
            </p>
            <p class="more">
              Go to Assessment <i class="el-icon-arrow-right"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="hot-video">
      <div class="w-1200">
        <div class="title">
          <p><span></span> <b></b>Popular Videos</p>
          <div class="more" @click="toVideoFn">More <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="lists">
          <div class="list" v-for="(item, index) in videoList" @click="videoInfo = item; dialogVisible = true;"
            v-appear-animation="{ appearClass: 'animate-fade-out' }">
            <img :src="item.image_url"></img>
            <p class="list-text">{{ item.news_title_en }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="message">
      <div class="message-con">
        <div class="title">Message Board</div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="Name">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="Mobile">
            <el-input v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="Address">
            <el-input v-model="form.source"></el-input>
          </el-form-item>
          <el-form-item label="Wechat">
            <el-input v-model="form.wxname"></el-input>
          </el-form-item>
          <el-form-item label="Visa Type">
            <el-select v-model="form.position" placeholder="Please select visa type">
              <el-option label="Studying Abroad (Australia)" value="留学申请(澳大利亚)"></el-option>
              <el-option label="Studying Abroad (New Zealand)" value="留学申请(新西兰)"></el-option>
              <el-option label="Skilled independent Visa" value="技术移民"></el-option>
              <el-option label="Skills in Demand Visa" value="雇主担保"></el-option>
              <el-option label="Partner Visa" value="配偶移民"></el-option>
              <el-option label="Contributory/Parent Visa" value="父母移民"></el-option>
              <el-option label="National Innovation Visa" value="NIV(国家创新签证)及投资移民"></el-option>
              <el-option label="155 Resident Return Visa" value="居民返程(155)签证"></el-option>
              <el-option label="Other Visa(600,407,485,500,590 etc.)" value="其他签证(600,407,485,500,590等)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Message">
            <el-input type="textarea" v-model="form.about"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="feedback">
      <div class="title">Feedback</div>
      <div class="lists">
        <div class="list" v-for="item in suggestList">
          <div class="tops">
            <img src="../../assets/contact/feedback.png" alt="">
            <div class="name">
              <p>{{ item.news_title_en }}</p>
              <el-rate v-model="item.hit" :colors="colors" disabled></el-rate>
            </div>
          </div>
          <!-- <div class="text">{{ item.news_about }}</div> -->
          <el-image fit="contain" style="width: 100%; height: auto" :src="item.image_url"
            :preview-src-list="[item.image_url]">
          </el-image>
        </div>
      </div>

      <el-pagination style="margin: 20px auto 0;display: flex;align-items: center;justify-content: center;"
        v-model:current-page="sugPage" v-model:page-size="sugPagesize" background border layout="prev, pager, next"
        :total="sugTotal" @current-change="sugChange" />
    </div>
    <el-dialog :title="videoInfo.news_title" :visible.sync="dialogVisible" width="40%">
      <video v-if="dialogVisible" style="width: 100%;height: 70vh;" :src="videoInfo.url" controls></video>
    </el-dialog>
    <!-- 广告 -->
    <div class="ad" v-if="adShow">
      <span>Ad</span>
      <i class="el-icon-close" @click="adShow = false"></i>
      <img @click="lookBigImgFn" :src="adInfo.image_url" alt="">
    </div>
    <el-dialog :visible.sync="imgShow" width="70%" top>
      <img style="width: 100%;height: auto;" :src="adInfo.image_url" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      adShow: true,
      iframeShow: false,
      imgShow: false,
      form: {
        type_id: 1,
        title: "",
        email: "",
        mobile: "",
        source: "",
        wxname: "",
        position: "",
        about: ""
      },
      dialogVisible: false,
      observer: null,
      pictures: [
      ],
      videoList: [],
      videoInfo: {},
      adInfo: {},
      imgHeight: 100,
      value2: 4,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }

      sugPage: 1,
      sugPagesize: 6,
      suggestList: [],
      sugTotal: 0
    }
  },
  methods: {
    lookBigImgFn() {
      // 点击查看大图
      this.adShow = false;
      this.imgShow = true;

    },
    sugChange(val) {
      this.sugPage = val;
      this.getSuggestFn()
    },
    getSuggestFn() {
      this.$http.complaint_list({
        page: this.sugPage,
        pagesize: this.sugPagesize,
        type_id: 858
      }).then(res => {
        this.suggestList = res.data || [];
        this.sugTotal = Number(res.count)
      })
    },
    handleImageLoad(event) {
      this.$nextTick(() => {
        const imgHeight = event.target.naturalHeight; // 获取图片自然高度
        this.$refs.carousel.$el.style.height = `${imgHeight}px`; // 设置 carousel 的高度为图片高度
      });
    },
    toAdPageFn() {
      window.open(this.adInfo.url, '_blank')
    },
    getAdFn() {
      // 获取广告
      this.$http.news_list({
        type_id: 855
      }).then(res => {
        this.adInfo = res.data ? res.data[0] : {}
      })
    },
    getBannerFn() {
      this.$http.banner_list({
        type_id: 200
      }).then(res => {
        let list = res.data;
        let pic = []
        list.forEach(item => {
          pic.push(item.image_url)
        })
        this.pictures = pic;
      })
    },
    onSubmit() {
      // 都是必填
      if (!this.form.title || !this.form.email || !this.form.mobile || !this.form.source || !this.form.wxname || !this.form.position || !this.form.about) {
        this.$message.error('Please fill in all the information');
        return;
      }
      //  正则验证邮箱

      if (!this.validateEmail(this.form.email)) {
        this.$message.error('Please enter a valid email address');
        return;
      }
      this.$http.message_add(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success('Message sent successfully');
          this.form = {
            type_id: 1,
            title: "",
            email: "",
            mobile: "",
            source: "",
            wxname: "",
            position: "",
            about: ""
          }
        }
      })
    },
    validateEmail(email) {
      // 定义邮箱验证正则
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // 先判断是否为字符串，避免非字符串类型传入报错
      if (typeof email !== 'string') return false;
      // 使用 test 方法验证，返回布尔值
      return emailReg.test(email.trim());
    },

    toVideoFn() {
      this.$router.push('/en/video')
    },
    toPageFn(router) {
      this.$router.push(router)
    },
    getVideoFn() {
      this.$http.video_list({
        ifrecommend: 1,
        page: 1,
        pagesize: 8
      }).then(res => {
        this.videoList = res.data;
      })
    }
  },
  mounted() {

    setTimeout(() => {
      this.adShow = false
    }, 30 * 1000);
    // 页面滚到最顶部 
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    })

    this.getBannerFn();
    this.getVideoFn();
    this.getAdFn();
    this.getSuggestFn()
  },
  beforeDestroy() {
  }
}
</script>

<style lang="less" scoped>
// 深黑 333333
// 浅黑 c4cad6
.index {
  width: 100vw;
  position: relative;
  user-select: none;
  height: auto;

  .el-button {
    background-color: #333333 !important;
  }

  .feedback {
    padding: 70px 0 70px;
    margin-bottom: 80px;

    .title {
      font-size: 40px;
      font-weight: 600;
      color: #222222;
      text-align: center;
      margin-bottom: 80px;
    }

    .lists {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
    }

    .list {
      width: calc(33% - 13px);
      margin-bottom: 20px;
      padding: 20px;
      border-radius: 10px;
      background-color: #f1f1f1;
      margin-right: 15px;
      box-sizing: border-box;

      .left {
        flex: 1;
      }
    }

    .list:nth-of-type(3n) {
      margin-right: 0;
    }

    .tops {
      display: flex;
      margin-bottom: 10px;
    }

    .tops img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-right: 20px;
    }

    .tops p {
      font-size: 18px;
      font-weight: 600;
      color: #222222;
    }

    .tops span {
      font-size: 14px;
      color: #666666;
    }

    .bottom {
      margin-top: 20px;
      font-size: 16px;
      color: #222222;
    }

  }

  .ad {
    position: fixed;
    top: 190px;
    left: 50%;
    z-index: 9999;
    // animation: scale 1.5s infinite;
    background-color: #fff;
    margin-left: -20%;
    width: 40%;
    height: auto;
    border-radius: 10px;
    border: 1px solid #333333;
    box-shadow: 0 0 10px #333333;

    span {
      position: absolute;
      left: 0;
      bottom: 100%;
      color: #333333;
      background-color: #f0c3a366;
      padding: 0 10px;
    }

    .el-icon-close {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 30px;
      height: 30px;
      background-color: #333333;
      color: #fff;
      border-radius: 50%;
      display: flex;
      font-size: 25px;
      z-index: 99;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }


    img {
      width: 100%;
      height: auto;
      border-radius: 10px;
      // object-fit: contain;
    }
  }

  @keyframes scale {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.05);
    }

    100% {
      transform: scale(1);
    }
  }

  .message {
    max-width: 1200px;
    margin: 50px auto;
    display: flex;

    .message-con {
      background-color: #f1f1f1;
      flex: 3;
      padding: 20px 40px 20px 20px;
      box-sizing: border-box;
      margin-left: 10px;
      border: 1px solid #666;
      border-radius: 10px;


      /deep/.el-form {
        display: flex;
        flex-wrap: wrap;
      }

      /deep/.el-form-item {
        width: calc(50% - 12px);
        margin-right: 20px;
      }

      /deep/.el-form-item:nth-of-type(2n) {
        margin-right: 0;
      }

      /deep/.el-form-item__label {
        color: #333333;
      }
    }


    .title {
      text-align: center;
      margin-bottom: 20px;
      font-size: 25px;
      color: #333333;
      font-weight: 500;
    }
  }

  .iframe-google {
    flex: 7;
    height: 600px;
    display: block;
    width: 100%;
  }

  .hot-video {
    padding: 100px 0 120px;
    border-bottom: 1px solid #333333;
    border-top: 1px solid #333333;
    margin-bottom: 30px;

    .w-1200 {
      max-width: 1200px;
      margin: 0 auto;
    }

    .title {
      text-align: center;
      position: relative;
      font-size: 26px;
      display: flex;
      color: #333333;
      justify-content: space-between;
      margin-bottom: 30px;

      span {
        height: 24px;
        width: 2px;
        background-color: #333333;
        display: inline-block;
        margin-right: 3px;
      }

      b {
        height: 24px;
        width: 2px;
        transform: scaleX(0.6);
        background-color: #333333;
        display: inline-block;
        margin-right: 10px;
      }

      p {
        display: flex;
        align-items: center;
      }

      .more {
        cursor: pointer;
        z-index: 2;
        padding: 0 20px;
        position: relative;
        font-size: 20px;
        color: #333333;
        display: flex;
        align-items: center;

        img {
          width: 30px;
        }
      }
    }

    .lists {
      display: flex;
      flex-wrap: wrap;

      .list {
        width: calc(25% - 20px);
        margin-right: 23px;
        margin-bottom: 30px;
        cursor: pointer;

        &:hover {

          video,
          img {
            box-shadow: 0 8px 7px 0 rgba(0, 0, 0, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.1);
          }
        }
      }

      video,
      img {
        transition: .3s all;
        width: 100%;
        height: 200px;
        object-fit: cover;
        border-radius: 8px;
      }

      .list:nth-of-type(4n) {
        margin-right: 0;
      }

      .list-text {
        padding: 10px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: center;
        color: #333333;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .country {
    padding: 100px 0;

    .w-1200 {
      max-width: 1200px;
      margin: 0 auto;
    }

    .lists {
      padding-top: 80px;
      display: flex;
      justify-content: space-between;

      .list {
        width: calc(25% - 25px);
        height: 350px;
        position: relative;
        cursor: pointer;
      }

      .list:hover {
        .img img {
          // 图片旋转
          transform: rotate(360deg);
        }

        .bg img {
          transform: scale(1.2);
        }

        .bg img {
          transform: scale(1.2);
        }

        .alert {
          height: 100%;
        }
      }

      .alert {
        transition: .5s all;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0;
        background-color: rgba(140, 95, 4, 0.6);
        color: #fff;
        font-size: 26px;
        font-weight: 500;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        transform-origin: bottom;
      }

      .img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -50px;
        left: 50%;
        transform: translate(-50%);
        z-index: 2;
        padding: 5px;
        box-sizing: border-box;
        background-color: #fff;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          transition: .3s all;
        }
      }

      .bg {
        width: 100%;
        overflow: hidden;
        height: 100%;
        border-radius: 10px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: .3s all;
        }
      }
    }

    .title {
      text-align: center;
      position: relative;

      span {
        background-color: #fff;
        z-index: 2;
        padding: 0 20px;
        position: relative;
        color: #333333;
        font-size: 22px;
        text-transform: uppercase;
      }

      &::before {
        content: "";
        width: 500px;
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translateX(-50%);
        border-bottom: 2px solid #808285;
      }

      &::after {
        content: "";
        width: 350px;
        position: absolute;
        left: 50%;
        top: 12px;
        transform: translateX(-50%);
        border-bottom: 2px solid #9ea1a9;
      }

    }

    .big-title {
      font-weight: 600;
      text-align: center;
      padding: 0 0 40px;
      font-size: 40px;
      color: #333333;
    }

    .text {
      max-width: 1100px;
      text-indent: 2em;
      margin: 0 auto 40px;
      color: #404450;
    }

  }

  .why-choose {
    padding: 100px 0;
    background-color: #f1f1f1;

    .w-1200 {
      max-width: 1200px;
      margin: 0 auto;
    }

    .title {
      text-align: center;
      position: relative;

      span {
        background-color: #f1f1f1;
        z-index: 2;
        padding: 0 20px;
        position: relative;
        color: #333333;
        font-size: 22px;
        text-transform: uppercase;
      }

      &::before {
        content: "";
        width: 500px;
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translateX(-50%);
        border-bottom: 2px solid #808285;
      }

      &::after {
        content: "";
        width: 350px;
        position: absolute;
        left: 50%;
        top: 12px;
        transform: translateX(-50%);
        border-bottom: 2px solid #9ea1a9;
      }

    }

    .big-title {
      font-weight: 600;
      text-align: center;
      padding: 0 0 40px;
      font-size: 40px;
      color: #333333;
    }

    .text {
      max-width: 1100px;
      text-indent: 2em;
      margin: 0 auto 40px;
      color: #404450;
    }

    .lists {
      display: flex;
      justify-content: space-between;

      .list {
        flex: 1;
        margin-right: 15px;
        background-color: #ffffffd6;
        padding: 20px 10px;
        box-sizing: border-box;
        border-radius: 10px;
        cursor: pointer;
        transition: .3s all;

        .list-title {
          color: #333333;
          font-size: 20px;
          text-align: center;
          font-weight: 500;
          margin-bottom: 10px;
          transition: .3s all;
          height: 54px;
        }

        .list-text {
          color: #404450;
          font-size: 14px;
          text-align: center;
          transition: .3s all;
          margin-bottom: 20px;
          height: 60px;
          text-indent: 20px;
        }

        .more {
          color: #333333;
          font-weight: 500;
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: end;
        }

        &:hover {
          background-color: #fff;
          transform: scale(1.1);
          box-shadow: 0 0 10px #74787f;

          .list-title {
            font-size: 23px;
          }
        }
      }

      .list:nth-of-last-type(1) {
        margin-right: 0;
      }

      .img {
        width: 80px;
        height: 80px;
        border-radius: 10px;
        background-color: #fff;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 1px solid #74787f;
        margin-bottom: 20px;

        img {
          width: 70%;
        }
      }
    }

  }

  .container-fluid {
    padding: 100px 0;

    .w-1200 {
      max-width: 1200px;
      margin: 0 auto;
    }

    .title {
      text-align: center;
      position: relative;

      span {
        background-color: #fff;
        z-index: 2;
        padding: 0 20px;
        position: relative;
        color: #333333;
        font-size: 22px;
        text-transform: uppercase;
      }

      &::before {
        content: "";
        width: 500px;
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translateX(-50%);
        border-bottom: 2px solid #808285;
      }

      &::after {
        content: "";
        width: 350px;
        position: absolute;
        left: 50%;
        top: 12px;
        transform: translateX(-50%);
        border-bottom: 2px solid #9ea1a9;
      }
    }

    .big-title {
      font-weight: 600;
      text-align: center;
      padding: 0 0 40px;
      font-size: 40px;
      color: #333333;
    }

    .text {
      max-width: 1100px;
      margin: 0 auto 40px;
      color: #404450;
      text-indent: 2em;
    }

    .lists {
      display: flex;
      flex-wrap: wrap;

      .list {
        width: calc(33% - 30px);
        position: relative;
        margin-right: 45px;
        margin-bottom: 60px;
        height: 350px;
        overflow: hidden;
        cursor: pointer;
      }

      .list-alert {
        transition: .6s all;
        position: absolute;
        bottom: 0;
        z-index: 5;
        left: 50%;
        transform: translate(-50%, 100%);
        background-color: #333333;
        border-radius: 10px;
        width: 90%;
        height: 280px;
        padding: 0 10px;
        box-sizing: border-box;


        .alert-title {
          height: 50px;
          border-bottom: 1px solid #ffffff8b;
          color: #fff;
          font-size: 20px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .alert-tip {
          height: calc(100% - 120px);
          padding: 10px 0;
          color: rgba(255, 255, 255, .8);
          text-indent: 2em;
          box-sizing: border-box;
          line-height: 1.8;
        }

        .alert-more {
          height: 40px;
          color: #fff;
          font-size: 16px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          width: 150px;
          margin: 0 auto;
          border-radius: 10px;
          background-color: #87898d;
        }
      }

      .list:hover {
        .big-img::after {
          transform: translateY(0);
        }

        .big-img img {
          transform: scale(1.2);
        }

        .list-alert {
          transform: translate(-50%, 0);
        }
      }

      .list:nth-child(3n) {
        margin-right: 0;
      }

      .text-title {
        background-color: #333333;
        width: 230px;
        margin: 0 auto;
        padding: 10px 0;
        color: #fff;
        font-size: 20px;
        text-align: center;
        font-weight: 600;
        margin-bottom: 20px;
        border-radius: 6px;
        margin-top: -50px;
        z-index: 4;
        position: relative;
      }

      .big-img {
        width: 100%;
        height: 300px;
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        margin-bottom: 20px;
        border: 1px solid #d6dade;
        box-sizing: border-box;

        &::after {
          content: '';
          left: 0;
          width: 100%;
          top: 0;
          height: 100%;
          background-color: rgba(255, 255, 255, .3);
          z-index: 2;
          position: absolute;
          transform: translateY(100%);
          transition: .6s all;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: .6s all;
        }
      }

      .text-title {
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 20px;
      }

      .more {
        font-size: 16px;
        text-align: center;
        color: #333333;
        cursor: pointer;
      }
    }

  }

  .counter-facts {
    background: linear-gradient(rgba(255, 255, 255, .9), rgba(255, 255, 255, 0.8)), url(../../assets/imgs/breadcrumb.png);
    background-size: cover;
    background-attachment: fixed;
    background-position: center center;
    background-repeat: no-repeat;
    padding: 100px 0;

    .lists {
      display: flex;
      justify-content: space-between;
    }

    .list {
      width: 220px;
      position: relative;
      text-align: center;
      min-height: 215px;
      margin: 0 auto;
      border-radius: 100px;
      box-shadow: 0 8px 5px rgba(0, 0, 0, 0.2);
      background: #fff;

    }

    .top {
      height: 105px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        position: relative;
        z-index: 2;
        height: 60px;
        width: auto;
        top: -30px;
      }

      &::before {
        content: "";
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        border-radius: 10px 10px 0 0;
        background-color: #333333;
      }

      &::after {
        content: '';
        width: 100px;
        height: 100px;
        position: absolute;
        margin: 0 auto 10px;
        top: -20px;
        border-radius: 10px 10px 0 0;
        font-size: 50px;
        background: #e2c25b;
        clip-path: polygon(0% 0%, 100% 0, 100% 70%, 50% 100%, 0 70%);
      }

      span {
        content: "";
        position: absolute;
        width: 100px;
        height: 90px;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 10px 10px 0 0;
        background: #9b9da0;
        clip-path: polygon(0% 0%, 100% 0, 100% 70%, 50% 100%, 0 70%);
      }
    }

    .bottom {
      font-size: 17px;
      font-weight: 600;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #333333;
      padding-top: 20px;

      .num {
        font-size: 30px;
        font-weight: 700;
        color: #9b9da0;
      }
    }
  }

  .about {
    margin: 80px auto;

    .w-1200 {
      max-width: 1200px;
      margin: 0 auto;
    }

    .con {
      display: flex;
    }

    .left {
      width: 34%;
      margin-right: 30px;
      background-color: #ecc35439;
      background-image: url('http://www.newlegend.com.au/01/img/about-2.png');
      padding-top: 180px;
      background-size: 100% auto;
      background-position: top center;
      height: 300px;
      position: relative;

      img {
        width: 100%;
        height: auto;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top-right-radius: 300px;
        border-top-left-radius: 300px;
      }
    }

    .right {
      flex: 1;

      .title {
        padding-top: 20px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        margin-bottom: 20px;

        span {
          width: 50px;
          display: inline-block;
          height: 1px;
          background-color: #5396f8;
          position: relative;
          top: -10px;

          &::after {
            position: absolute;
            content: '';
            left: 0;
            bottom: -10px;
            width: 100px;
            height: 1px;
            background-color: #333333;
          }
        }
      }


      .big-title {
        font-size: 40px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 40px;
      }


      .text {
        font-size: 16px;
        color: #404450;
        line-height: 1.5;
        margin-bottom: 20px;
        margin-bottom: 70px;
      }
    }
  }

  .big-pic {
    width: 100%;
    max-width: 1200px;
    height: auto;
    display: block;
    font-size: 30px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    margin: 0 auto 10px;
    line-height: 1.5;
    padding: 40px 0;
    text-shadow: 3px 3px 3px #333333;
    letter-spacing: 2px;


    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

  }

  .big-bg {
    position: relative;
    width: 100vw;
    height: 550px;

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .el-carousel,
    .el-carousel__container,
    .el-carousel__item {
      width: 1200px;
      margin: 0 auto;
      height: 550px;
    }

    .el-carousel__item {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/ .el-carousel__arrow {
      transform: scale(1.5);
      background-color: rgba(0, 0, 0, .3);
      color: #fff;

      i {
        font-size: 30px;
      }
    }

  }
}


/* 当屏幕宽度小于600px时 */
@media (max-width: 899px) {
  .index {

    .big-bg,
    /deep/.el-carousel,
    /deep/.el-carousel__container,
    .pic {
      height: 150px !important;
    }

    .big-bg {
      position: relative;
      width: 100vw;
      height: 150px;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }

      .el-carousel,
      .el-carousel__container,
      .el-carousel__item {
        width: 100%;
        margin: 0 auto;
        height: 150px;
      }
    }


    /deep/.el-image .el-image__preview {
      object-fit: contain !important;
      width: 100%;
      height: auto;
    }

    .big-pic {
      padding: 20px 0;
      font-size: 20px;
    }

    .container-fluid {
      padding: 40px 0;

      .title {
        zoom: 0.6;
      }

      .big-title {
        font-size: 20px;
        padding: 0 20px;
        font-weight: 500;
        text-align: center;
      }

      .text {
        margin: 0 auto 20px;
        font-size: 14px;
        padding: 0 20px;
        text-align: justify;
      }

      .lists {
        display: block;
        padding: 0 20px;
        box-sizing: border-box;

        .list {
          width: 100%;
          margin-right: 0;
          margin-bottom: 40px;
          height: 300px;
        }

        .big-img {
          height: 250px;
        }

        .text-title {
          font-size: 18px;
          width: 200px;
          padding: 8px 0;
        }

        .list-alert {
          height: 240px;

          .alert-title {
            font-size: 18px;
            height: 40px;
          }

          .alert-more {
            width: 120px;
            font-size: 14px;
          }
        }
      }
    }

    .why-choose {
      padding: 60px 0;

      .title {
        zoom: 0.6;
      }

      .big-title {
        font-size: 20px;
        padding: 0 20px;
        font-weight: 500;
        text-align: center;
      }

      .text {
        margin: 0 auto 20px;
        font-size: 14px;
        padding: 0 20px;
        text-align: justify;
      }

      .lists {
        display: block;
        padding: 0 20px;
        box-sizing: border-box;

        .list {
          width: 100%;
          margin-right: 0;
          margin-bottom: 30px;
          padding: 15px;
        }

        .list-title {
          font-size: 18px;
          height: 45px;
        }

        .list-text {
          font-size: 13px;
          height: 50px;
          margin-bottom: 15px;
        }

        .more {
          font-size: 14px;
        }

        .img {
          width: 70px;
          height: 70px;
          margin-bottom: 15px;
        }
      }
    }

    .hot-video {
      padding: 50px 20px;
      box-sizing: border-box;

      .title {
        font-size: 18px;
        padding: 0 20px;

        .more {
          font-size: 14px;
        }
      }

      .lists {
        display: block;

        .list {
          width: 100%;
          margin-right: 0;
          margin-bottom: 30px;
        }

        video,
        img {
          height: 180px;
        }

        .list-text {
          font-size: 16px;
          padding: 8px;
        }
      }
    }

    .message {
      display: block;
      padding: 0 20px;

      .message-con {
        margin-left: 0;
        padding: 15px;

        /deep/.el-form-item {
          width: 100%;
          margin-right: 0;
        }

        .title {
          font-size: 20px;
        }
      }
    }

    .feedback {
      padding: 50px 20px;
      margin-bottom: 50px;

      .title {
        font-size: 30px;
        margin-bottom: 50px;
      }

      .lists {
        width: 100%;
        padding: 0;

        .list {
          width: 100%;
          margin-right: 0;
          margin-bottom: 20px;
          padding: 15px;
        }
      }
    }

    .ad {
      width: 80%;
      margin-left: -40%;
      top: 150px;
    }

  }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
  .index {

    .big-bg,
    /deep/.el-carousel,
    /deep/.el-carousel__container,
    .pic {
      height: 100px !important;
      width: 100%;
    }

    .big-bg {
      position: relative;
      width: 100vw;
      height: 100px;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }

      .el-carousel,
      .el-carousel__container,
      .el-carousel__item {
        width: 100%;
        margin: 0 auto;
        height: 100px;
      }
    }

    .big-pic {
      padding: 15px 0;
      font-size: 18px;
    }

    .container-fluid {
      padding: 30px 0;

      .big-title {
        font-size: 18px;
      }

      .text {
        font-size: 13px;
      }

      .lists {
        .list {
          height: 280px;
        }

        .big-img {
          height: 230px;
        }

        .text-title {
          font-size: 16px;
          width: 180px;
          padding: 6px 0;
        }

        .list-alert {
          height: 220px;

          .alert-title {
            font-size: 16px;
            height: 35px;
          }

          .alert-more {
            width: 100px;
            font-size: 13px;
          }
        }
      }
    }

    .why-choose {
      padding: 40px 0;

      .big-title {
        font-size: 18px;
      }

      .text {
        font-size: 13px;
      }

      .lists {
        .list {
          margin-bottom: 20px;
          padding: 10px;
        }

        .list-title {
          font-size: 16px;
          height: 40px;
        }

        .list-text {
          font-size: 12px;
          height: 45px;
          margin-bottom: 10px;
        }

        .more {
          font-size: 13px;
        }

        .img {
          width: 60px;
          height: 60px;
          margin-bottom: 10px;
        }
      }
    }

    .hot-video {
      padding: 40px 20px;

      .title {
        font-size: 16px;
      }

      .lists {
        .list {
          margin-bottom: 20px;
        }

        video,
        img {
          height: 160px;
        }

        .list-text {
          font-size: 14px;
          padding: 6px;
        }
      }
    }

    .message {
      .message-con {
        padding: 10px;

        .title {
          font-size: 18px;
        }

        /deep/.el-input__inner {
          font-size: 13px;
        }

        /deep/.el-button {
          font-size: 13px;
        }
      }
    }

    .feedback {
      padding: 40px 20px;
      margin-bottom: 40px;

      .title {
        font-size: 25px;
        margin-bottom: 40px;
      }

      .lists {
        .list {
          padding: 10px;
        }

        .tops p {
          font-size: 16px;
        }
      }
    }

    .ad {
      width: 90%;
      margin-left: -45%;
      top: 130px;
    }

  }
}

/* 当屏幕宽度在600px到900px之间时 */
@media (min-width: 600px) and (max-width: 899px) {}

/* 当屏幕宽度大于900px时 */
@media (min-width: 900px) {}
</style>



// WEBPACK FOOTER //
// src/views/en/index.vue